import * as actions from './actions'
import * as types from './mutation-types'

const state = {
  consumablesLoading: false,
  consumablesError: {},
  consumables: []
}

const getters = {
  consumablesLoading: state => state.consumablesLoading,
  consumablesError: state => state.consumablesError,
  consumables: state => state.consumables
}

const mutations = {
  [types.GET_CONSUMABLES_STATUS_REQUEST] (state) {
    state.consumablesLoading = true
    state.consumablesError = {}
    state.consumables = []
  },
  [types.GET_CONSUMABLES_STATUS_FAILURE] (state, consumablesError) {
    state.consumablesLoading = false
    state.consumablesError = consumablesError
    state.consumables = []
  },
  [types.GET_CONSUMABLES_STATUS_SUCCESS] (state, consumables) {
    state.consumablesLoading = false
    state.consumablesError = {}
    state.consumables = consumables
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
